import React from 'react';
import ToneGenerator from './components/ToneGenerator';

function App() {
  return (
    <div className="demo-container">
      <ToneGenerator />
    </div>
  );
}

export default App;
